import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { CROSS_CHECK_RESULT_STATUS } from "../../queries";

export const useCrossCheckUtils = () => {
  const client = useApolloClient();

  const getCrossCheckComparison = (source, other, color) => {
    if (!source) return { color, data: null };
    return {
      color,
      data: {
        insurerName: {
          value: source.insurerName,
          changed: !other && true
        },
        conventionName: {
          value: source.conventionName,
          changed: !other ? false : source.conventionName !== other.conventionName
        },
        period: {
          value: source.period,
          changed: false
        },
        currencyCode: {
          value: source.currencyCode,
          changed: !other ? false : source.currencyCode !== other.currencyCode
        },
        insuranceAmount: {
          value: source.insuranceAmount,
          changed: !other ? false : source.insuranceAmount !== other.insuranceAmount
        },
        totalInsuranceAmount: {
          value: source.totalInsuranceAmount,
          changed: !other ? false : source.totalInsuranceAmount !== other.totalInsuranceAmount
        }
      }
    };
  };

  const getRcaCrossCheckComparison = (source, other, color) => {
    if (!source) return { color, data: null };
    const sourceDetailWithDD = source.details.find(x => x.isDirectCompensation);
    const sourceDetailWithoutDD = source.details.find(x => !x.isDirectCompensation);
    const otherDetailWithDD = other.details.find(x => x.isDirectCompensation);
    const otherDetailWithoutDD = other.details.find(x => !x.isDirectCompensation);
    return {
      color,
      data: {
        insurerName: {
          value: source.insurerName,
          changed: !other && true
        },
        insuranceAmountWithDD: {
          value: sourceDetailWithDD?.insuranceAmount,
          changed: sourceDetailWithDD?.insuranceAmount !== otherDetailWithDD?.insuranceAmount
        },
        insuranceAmountWithoutDD: {
          value: sourceDetailWithoutDD?.insuranceAmount,
          changed: sourceDetailWithoutDD?.insuranceAmount !== otherDetailWithoutDD?.insuranceAmount
        },
        currencyCode: {
          value: source.currencyCode,
          changed: !other ? false : source.currencyCode !== other.currencyCode
        }
      }
    };
  };

  //#region Watch
  const watchCrossCheckStatus = useCallback(
    callback =>
      client
        .watchQuery({
          query: CROSS_CHECK_RESULT_STATUS
        })
        .subscribe({
          next: ({ data }) => {
            const items = data?.crossCheckResultStatus?.data || [];
            callback(items);
          }
        }),
    [client]
  );
  // #endregion

  //#region Read
  const getCrossCheckStatus = useCallback(() => {
    const { crossCheckResultStatus } = client.readQuery({ query: CROSS_CHECK_RESULT_STATUS });
    if (!crossCheckResultStatus || !crossCheckResultStatus.data) return [];
    return crossCheckResultStatus;
  }, [client]);
  // #endregion

  //#region Update
  const updateCrossChecksSelectedStatus = useCallback(
    data =>
      client.writeQuery({
        query: CROSS_CHECK_RESULT_STATUS,
        data: {
          crossCheckResultStatus: {
            __typename: "crossCheckResultStatus",
            data
          }
        }
      }),
    [client]
  );

  const updateCrossCheckResultStatus = useCallback(
    crossCheckResult => {
      const crossCheckResultStatus = getCrossCheckStatus();

      client.writeQuery({
        query: CROSS_CHECK_RESULT_STATUS,
        data: {
          crossCheckResultStatus: {
            __typename: "crossCheckResultStatus",
            data: crossCheckResultStatus.data.map(x => ({
              ...x,
              loading: x.documentId === crossCheckResult.documentId ? false : x.loading
            }))
          }
        }
      });
    },
    [client, getCrossCheckStatus]
  );
  // #endregion

  return {
    getCrossCheckComparison,
    getRcaCrossCheckComparison,
    watchCrossCheckStatus,
    getCrossCheckStatus,
    updateCrossChecksSelectedStatus,
    updateCrossCheckResultStatus
  };
};
